/** Touch-first / narrow viewports — used to stagger heavy canvas and image work. */
export const isMobileDevice = (): boolean => {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPhone|iPad|iPod|Android/i.test(ua)
    || (navigator.maxTouchPoints > 1 && window.innerWidth < 1024);
};

/**
 * Phone / in-app WebView canvas export — same WebKit font sizing bugs as mobile Safari.
 * Broader than {@link isMobileDevice} so stadium/score raster fixes apply in Yinzcam/social WebViews.
 */
export const isMobileCanvasExport = (): boolean => {
  if (typeof window === "undefined") return false;
  if (isMobileDevice()) return true;
  const ua = navigator.userAgent || "";
  return /wv|WebView|FBAN|FBAV|Instagram|MicroMessenger|Twitter|Snapchat|Yinzcam/i.test(ua)
    || (/\(iP(hone|od|ad);/i.test(ua) && !/Safari/i.test(ua));
};
